import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "UpNext", webpackPrefetch: true */ './lazyIndex');
});
// Delayed Loaded Actions
export var lazyInitializeUpNext = new LazyImport(lazyModule, function (m) { return m.initializeUpNext; });
export var lazyOnCalendarNotification = new LazyImport(lazyModule, function (m) { return m.onCalendarNotification; });
// Delayed Loaded Components
export var UpNext = createLazyComponent(lazyModule, function (m) { return m.UpNext; });
//# sourceMappingURL=index.js.map